import { useState } from "react";
import Menu from "./components/Menu/Menu";
import Desktop from "./components/Desktop";
import Dock from "./components/Dock/Dock";

import styles from "./App.module.css";

const App = () => {
  const [openFolderName, setOpenFolderName] = useState(null);
  const [folderClicked, setFolderClicked] = useState("");
  const [showPopup, setShowPopup] = useState(true);

  const handleFullScreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    }
    setShowPopup(false);
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  return (
    <div
      className={`${styles.container} ${styles.noselect}`}
      onClick={() => {
        setFolderClicked("");
        handleCancel();
      }}
    >
      {showPopup && (
        <div className={styles.popup}>
          <h2>Full Screen Mode</h2>
          <h3>
            For a better experience, would you like to enable full screen mode?
          </h3>
          <button id={styles["cancel"]} onClick={handleCancel}>
            Cancel
          </button>
          <button id={styles["enable"]} onClick={handleFullScreen}>
            OK
          </button>
        </div>
      )}
      <Menu />
      <Desktop
        openFolderName={openFolderName}
        setOpenFolderName={setOpenFolderName}
        clicked={folderClicked}
        setClicked={setFolderClicked}
      />
      <Dock />
    </div>
  );
};

export default App;
